export default __webpack_public_path__ + "media/images/signup/communication-6814cc8241be0953c47460ef9501435b.png";